export default {
  Gallery: null,
  Camera: 'camera'
}